module.exports = __webpack_public_path__ + "media/images/athletes/2821-44bf7523fdc34249622e16a2c529cc97.png";